export default __webpack_public_path__ + "static/media/upArrow.ec297374.svg";